
export enum BadgeColor {
	GREY = "text-gray-700 bg-gray-200",
	GREEN = "text-green-800 bg-green-100"
}
